import React, { useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useLocale } from "../context/LocaleContext";
import "../styles/root.css";
import "../styles/pages.css";

const REPORTS = [
  {
    year: 2025,
    file: "/documents/annual-reports/anisija-annual-report-2025.pdf",
    available: true,
  },
  {
    year: 2024,
    file: "/documents/annual-reports/anisija-annual-report-2024.pdf",
    available: false,
  },
  {
    year: 2023,
    file: "/documents/annual-reports/anisija-annual-report-2023.pdf",
    available: false,
  },
];

function EyeSlashIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M3 3l18 18" />
      <path d="M10.6 10.6a2 2 0 102.8 2.8" />
      <path d="M9.9 5.4A11 11 0 0112 5c5.6 0 9.2 5.1 9.7 5.8a1 1 0 010 1.2c-.4.6-2.6 3.8-6.2 5.2" />
      <path d="M6.2 6.2C3.9 7.7 2.5 9.7 2.3 10a1 1 0 000 1.2C2.8 11.9 6.4 17 12 17c.8 0 1.6-.1 2.3-.3" />
    </svg>
  );
}

function AnnualReports() {
  const { t } = useLocale();
  const revealRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const addRef = (el) => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
    }
  };

  return (
    <div>
      <Navbar />

      <div className="page-hero">
        <div className="page-hero-inner">
          <span className="page-hero-eyebrow">{t.nav.documents}</span>
          <h1 className="page-hero-title">{t.annualReports.headline}</h1>
          <div className="page-hero-line" />
        </div>
      </div>

      <div className="page-container">
        <p className="reports-intro-text">{t.annualReports.intro}</p>

        <div className="reports-grid-new">
          {REPORTS.map((report, i) => {
            const reportTitle = `${t.annualReports.reportTitlePrefix} ${report.year}`;

            return (
              <article
                key={report.year}
                className={`report-card-new${report.available ? "" : " report-unavailable"}`}
                ref={addRef}
                style={{ "--delay": `${i * 100}ms` }}
              >
                <div className="reveal-up">
                  <div className="report-card-year">{report.year}</div>
                  <h2 className="report-card-title">{reportTitle}</h2>
                  <p className="report-card-format">{t.annualReports.formatLabel}</p>

                  {report.available ? (
                    <div className="report-card-actions">
                      <a
                        href={report.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="report-btn report-btn-primary"
                      >
                        {t.annualReports.open}
                      </a>
                      <a
                        href={report.file}
                        download
                        className="report-btn report-btn-outline"
                      >
                        {t.annualReports.download}
                      </a>
                    </div>
                  ) : (
                    <div className="report-card-unavail">
                      <span className="report-card-unavail-icon" aria-hidden="true">
                        <EyeSlashIcon />
                      </span>
                      <p>{t.annualReports.unavailable}</p>
                    </div>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AnnualReports;
